module.exports = __webpack_public_path__ + "static/img/fpdj_selected_image.bd9042e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/fpdj_selected_image.png
// module id = wfVU
// module chunks = 44